export default "__VITE_ASSET__D1uTwLq2__"